// extracted by mini-css-extract-plugin
module.exports = {"contact":"ContactBlock_contact__vw9Kr","text":"ContactBlock_text__eBjLq","phone":"ContactBlock_phone__XRbBV","email":"ContactBlock_email__E9Adi","bold":"ContactBlock_bold__yfu0H"};